// import { useEffect, useRef } from 'react';
import {Fragment, useMemo} from 'react';
import classNames from 'classnames';
import Split from 'react-split';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IObjString, IlistItem } from '@/utils/ctype';
import { IMainContent } from '@/utils/ctype';
import { isArticleTitle } from '@/utils/articleTitle';
import GroupTitle from '@/pages/Mock/components/GroupTitle';
import { getArticleImageHeight } from '@/utils/articleImageSize';
import Group from '../Group';
import DragAI from '../../../components/DragAI';
import DropAI from '../../../components/DropAI';
import SubTitle from '../../../components/SubTitle';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';
import './index.less';

export default function MainContent(props: IMainContent) {
  const {question = [], pageData, displayAnswerMap, currentFocus = 0, saveAnswerHandle, answerMap, loadAnswered, isAI, boxStyle, index, feedback} = props;

  const {content, } = pageData.question;


  const {answerAllText} = pageData;

  const {paragraph, order_ary, order_aryHtml, title, sub_title, paragraph_title, paragraph_img, notes} = content;

  
  const keyIndex = question.findIndex((item) => item.type === 6);
  const titleData = keyIndex !== -1 ? question[keyIndex]: null;


  const {collectIdToContentMap, collectListIdToTitleMap} = useMemo(() => {
    const collectIdToContentMap: IObjString = {};
    const collectListIdToTitleMap: IObjString = {};
    if (titleData) {
      const { collect_option} = titleData;
      
      collect_option.list.forEach(({id, title, content}, index: number) => {
        collectIdToContentMap[id] = content;
        collectListIdToTitleMap[id] = title;
      });
    }
    return ({ collectIdToContentMap, collectListIdToTitleMap});
  }, [titleData]);

  const createAIType = (item: IlistItem, answer: string) => {
    // const letter = collectListIdToTitleMap[answer];
    // display_answer 为ABC 我拿到的answerData
    if (!feedback || !item) {
      return 'fail';
    }
    return feedback[item.id] || 'fail';
  };


  const createDrop = (key: string, index: number) => {
    if (!titleData || !titleData.list) {
      return null;
    }

    const item = titleData.list.find(ele => ele.sub_essay_code === key);
    if (!item) {
      return null;
    }
    
    // const {list, group_id: groupId, type} = titleData;
    // const key = `${groupId}_${type}_${item.id}`;
    const answer = answerMap[key] && answerMap[key][0];
    const resultType = createAIType(item, answer);
    return (
      <DropAI
        data={item}
        key={index}
        type={resultType} 
        playAudio={()=> {playAudio(item);}} 
        parsingAI={() => {parsingAI(item);}} 
        blankBoxClass={style.blankBox}
        answerKey={`answerAllText.${item.number - 1}`}
        answer={answerAllText[item.number - 1] || collectIdToContentMap[answer]} 
        dataKey={`question.question.${keyIndex}.list.${index}.display_answerHtml`} 
        // optionClass={style.option}
        id={`question${item.number}`}
      />
    );
  };

  return (
    <div className={style.exercises} style={boxStyle}>
      <Split gutterSize={2} className={style.writingBox} dragInterval={1}>
        <div className={classNames(style.articleBox)} id={`article${index}`}>
          {title ? <div className={style.title} data-key={'question.content.title'}><HtmlParser htmlString={title}></HtmlParser></div> : null}
          {sub_title ? <div className={style.subTitle} data-key={'question.content.sub_title'}>
            {
              sub_title.split('\n').map((s, i) => {
                return <div key={i}><HtmlParser htmlString={s}></HtmlParser></div>;
              })
            }
          </div> : null}
          {
            !!content.image && typeof content.image === 'string' ? <div className={style.img}><img src={content.image} style={{ maxHeight: getArticleImageHeight(content.image) }} /></div> : null
          }

          {
            !!content['pre-A'] ? <>
              {
                (content['pre-A'] as string).split('\n').map((s, i) => {
                  return <p key={`pre_${index}_${i}`} className={style.content} data-key={`question.content.pre.${i}`}><HtmlParser htmlString={s}></HtmlParser>
                  </p>;
                })
              }
            </> : null
          }
          
          {
            order_ary ? order_ary.map((key, index: number) => {
              return (
                <div key={index}>
                  {/* <p className={style.letter} data-key={`~question.content.order_ary.${index}`}><HtmlParser htmlString={order_aryHtml[index]}></HtmlParser></p> */}
                  {
                    paragraph_title && paragraph_title[order_aryHtml[index]] ? <>
                      <p className={style.letter} data-key={`~question.content.order_ary.${index}`}><HtmlParser htmlString={paragraph_title[order_aryHtml[index]]}></HtmlParser></p>
                    </> : <>
                      <p className={style.letter} data-key={`~question.content.order_ary.${index}`}><HtmlParser htmlString={order_aryHtml[index]}></HtmlParser></p>
                    </>
                  }
                  {createDrop(key, index)}
                  <p className={style.content} data-key={`question.content.${key}`}><HtmlParser htmlString={(content[key] as string)}></HtmlParser></p>
                </div>
              ); 
            }) :
              null
          }
          {
            paragraph ? paragraph.map((str: string, index: number) => {
              const img = paragraph_img ? paragraph_img.find((ele) => ele.paragraph === index) : null;
              return <Fragment key={index}>
                <p className={style.content} key={index} data-key={`question.content.paragraph.${index}`}>
                  {
                    str.split('\n').map((s, i) => {
                      const b = isArticleTitle(s);

                      return <div className={classNames(style.content, b ? style.contentBold : '')} key={`${index}_${i}`}>
                        <HtmlParser htmlString={s}></HtmlParser>
                      </div>;
                    })
                  }
                </p>
                {
                  img ? <div className={style.img}><img src={img.img_url}  style={{ maxHeight: getArticleImageHeight(img.img_url) }} /></div> : null
                }
              </Fragment>;
            }) : null
          }
          {
            notes && notes.length > 0 ? <div className={style.notes}>
              {notes.map((note, i) => (
                <p key={i} className={style.noteItem}><HtmlParser htmlString={note}></HtmlParser></p>
              ))}
            </div> : null
          }
        </div>
        <div className={classNames(style.answer)} data-scroll>
          {
            question.map((item, index: number) => {
              return item.type !== 6 ? 
                <Group data={item} key={index} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} 
                  answerMap={answerMap} pageData={pageData} loadAnswered={loadAnswered} isAI={isAI} index={index}
                  feedbackMap={feedback}
                  displayAnswerMap={displayAnswerMap}
                  setShowDragFieldHandle={(val: boolean) => {}}></Group> : 
                <div key={index} className={style.answerList} >
                  <SubTitle desc={titleData!.desc} keyIndex={index} staticWidth></SubTitle>
                  <div style={{ marginTop: '20px' }}>

                    {
                      titleData && titleData.title ? <GroupTitle title={titleData?.title} /> : null
                    }
                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '30px', alignItems: 'flex-start' }}>

                      {
                        titleData!.collect_option.list.map((data, boxIndex: number) => {
                          return <DragAI 
                            data={data} key={boxIndex} optionClass={style.mt15}
                            dataKey={`question.question.${index}.collect_option.list.${boxIndex}.content`} 
                            titleKey={`$question.question.${index}.collect_option.list.${boxIndex}.title`} />;
                        })
                      }
                    </div>
                  </div>
                </div>;
            })
          }
        </div>
      </Split>
      
    </div>
  );
  
}